import { createApp } from 'vue'
import App from './App.vue'
import axios from './util/axios'
import VueAxios from 'vue-axios'

const app = createApp(App)

app.use(VueAxios, axios)

app.mount('#app')
